// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBsoszajXMpxTKTL7PCsFUxWzqD2iyEq1o",
    authDomain: "all-verify-with-assignment-9.firebaseapp.com",
    projectId: "all-verify-with-assignment-9",
    storageBucket: "all-verify-with-assignment-9.appspot.com",
    messagingSenderId: "179153204950",
    appId: "1:179153204950:web:6f5599e7c661898d5efb77"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
















// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyAX9lNMv1smOt_m9P6D_TtFZ3nSwT6mDqs",
//     authDomain: "short-quiz-mania.firebaseapp.com",
//     projectId: "short-quiz-mania",
//     storageBucket: "short-quiz-mania.appspot.com",
//     messagingSenderId: "36999224549",
//     appId: "1:36999224549:web:5792a51645aed03f53880c"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export default app;